'use strict';
import angular from 'angular';

import GoogleAdsBiddingHtmlUrl from './views/googleAdsBidding.list.html';

var app = angular.module('app.googleAdsBidding.component', []);

app.component('googleAdsBidding', {
    bindings: {
        selectedBiddings: '=',
        showActions: "=",
        modelValue : "=",
        clusterId: '=',
        isEdit:"=",
        campaignId:'='
    },
    templateUrl: GoogleAdsBiddingHtmlUrl,

    // The controller that handles our component logic
    controller: function($scope,$ioAlert, anchorSmoothScroll, $location, $timeout,ProductService, $stateParams, $rootScope) {
        var self = this;
        self.adPlacementLocations = ['ABSOLUTE_TOP_OF_PAGE', 'ANYWHERE_ON_PAGE', 'TOP_OF_PAGE'];
        /*
         * Initialize the component hide the add/edit operations based on showActions boolean value
         */
        $scope.$watch('$ctrl.modelValue.campaign_advertising_channel_type', function () {
            const type = (self.modelValue.campaign_advertising_channel_type || '').toLowerCase();

            if (type === 'search') {
                self.biddingMethods = ['MANUAL_CPC', 'MAXIMIZE_CONVERSIONS', 'TARGET_CPA', 'Target_ROAS', 'TARGET_IMPRESSION_SHARE'];
            } else if (type === 'display') {
                self.biddingMethods = ['MANUAL_CPC', 'MAXIMIZE_CONVERSIONS', 'Target_ROAS', 'VCPM', 'MAXIMIZE_CLICKS'];
            } else if (type === 'performance_max') {
                self.biddingMethods = ['MAXIMIZE_CONVERSIONS', 'TARGET_CPA', 'Target_ROAS'];
            } else {
                self.biddingMethods = ['MANUAL_CPC', 'MAXIMIZE_CONVERSIONS', 'TARGET_CPA', 'Target_ROAS', 'TARGET_IMPRESSION_SHARE', 'VCPM'];
            }
        });

        self.onChangeUserortfolio = function(){
            if(self.selectedBiddings.usePortfolio){
                self.selectedBiddings.useExistingPortfolio = true;
                self.selectedBiddings.createNewPortfolio = false;
            } else {
                self.selectedBiddings.useExistingPortfolio = false;
                self.selectedBiddings.createNewPortfolio = false;
                delete self.selectedBiddings.portfolioStrategy;
                delete self.selectedBiddings.portfolioName;
                delete self.selectedBiddings.portfolioBidAmount;
            }
        }

        self.onChangeCreatePortfolio = function(){
            if(self.selectedBiddings.useExistingPortfolio){
                self.selectedBiddings.useExistingPortfolio = false;
                delete self.selectedBiddings.portfolioStrategy;
            }
        }

        self.onChangeExistingPortfolio = function(){
            if(self.selectedBiddings.createNewPortfolio){
                self.selectedBiddings.createNewPortfolio = false;
                delete self.selectedBiddings.portfolioName;
                delete self.selectedBiddings.portfolioBidAmount;
            }
        }

        self.onChangeBiddingMethod = function(value){
            self.selectedBiddings = {
                bidding_method : value
            }
            if(value=='Target_ROAS' && self.campaignId){
                var params ={campaignId:self.campaignId}
                ProductService.getTrackedConversions(params).then(function(success) {
                    if(success.trackedConversions < 15){
                        $ioAlert.show('Error!',' There are not enough conversions to use Target ROAS. Select a different bid strategy or wait for the tracker to generate min 15 conversions', 'error');
                    }
                }, function(error) {
                    $ioAlert.show('Error!','Error while getting tracked conversions', error);
                })
            }
            if (value === 'TARGET_IMPRESSION_SHARE') {
                $rootScope.$broadcast('target_impression_share_enabled', true);
                self.adPlacementLocations.location = self.adPlacementLocations[1];
            } else {
                $rootScope.$broadcast('target_impression_share_enabled', false);
            }
        }
        self.onChangeAdPlacementLocationMethod = function (value) {
            self.selectedBiddings.location = value
        }

        self.getRoasBiddingStratagies = function(){
            var params ={
                clusterId:self.clusterId,
                contentKey:'google_ads_roas_shared_bid_strategies',
                order_id: $stateParams.orderId
            }
            ProductService.getRoasStrategies(params).then(function(success) {
                if(success.lookupContents && success.lookupContents.length > 0){
                    self.roasBiddingsList = success.lookupContents;
                }
            }, function(error) {
                $ioAlert.show('Error!','Error while getting bidding strategies', error);
            })
        }

        self.getCpaBiddingStratagies = function(){
            var params ={
                clusterId:self.clusterId,
                contentKey:'google_ads_cpa_shared_bid_strategies',
                order_id: $stateParams.orderId
            }
            ProductService.getCpaStrategies(params).then(function(success) {
                if(success.lookupContents && success.lookupContents.length > 0){
                    self.biddingsListCpa = success.lookupContents;
                }
            }, function(error) {
                $ioAlert.show('Error!','Error while getting bidding strategies', error);
            })
        }

        self.initComponent = function () {
            if (self.selectedBiddings) {
                self.selectedBiddings = JSON.parse(self.selectedBiddings);
                if (self.selectedBiddings.bidding_method === 'TARGET_IMPRESSION_SHARE') {
                    self.adPlacementLocations.location = self.selectedBiddings.location ? self.selectedBiddings.location : self.adPlacementLocations[1];
                }
                if(self.showActions){
                    self.enableViewMode = false;
                    self.getRoasBiddingStratagies();
                    self.getCpaBiddingStratagies();
                }else{
                    self.enableViewMode = true;
                }
            } else {
                self.selectedBiddings = {
                    bidding_method: ''
                };
                self.enableViewMode = self.showActions ? false : true;
                self.getRoasBiddingStratagies();
                self.getCpaBiddingStratagies();
            }
        };

        self.initComponent();
    }
});
